import { render, staticRenderFns } from "./IDScanConfirmDialog.vue?vue&type=template&id=5c8f31ee&"
import script from "./IDScanConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./IDScanConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports